(function (ws) {
    'use strict';

    ws.views.tableModalView = ws.views.modal.extend({

        TOPDOWN_PARENT_BUNDLE_TYPE: globals.bundles.TOPDOWN_PARENT_BUNDLE_TYPE,
        TOPDOWN_CHILD_BUNDLE_TYPE: globals.bundles.TOPDOWN_CHILD_BUNDLE_TYPE,
        ROLLUP_PARENT_BUNDLE_TYPE: globals.bundles.ROLLUP_PARENT_BUNDLE_TYPE,
        ROLLUP_CHILD_BUNDLE_TYPE: globals.bundles.ROLLUP_CHILD_BUNDLE_TYPE,
        STANDARD_TYPE: globals.bundles.STANDARD_TYPE,
        TECEX_TYPE: globals.bundles.TECEX_TYPE,
        VENDOR_PARENT_TYPE: globals.bundles.VENDOR_PARENT_TYPE,
        CISCO_PARENT_BUNDLE_TYPE: globals.bundles.CISCO_PARENT_TYPE,
        CISCO_CHILD_BUNDLE_TYPE: globals.bundles.CISCO_CHILD_TYPE,

        /**
         * Extend default events
         */
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .qut-modal-table-select-all-checkbox': 'selectAll',
            'click tbody > tr': 'multipleRowSelect'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.selectedProducts = [];
            this.collection = new ws.collections.modalTableCollection();
            this.buildViewHelpers();
        },

        /**
         * Render table data
         * @param {Object} tableData
         */
        renderTable: function(tableData) {
            this.onOpen();

            var model;
            var tableRow;
            this.collection.reset();
            var lineRowIndex = 0;
            var parentRowIndex;

            _.each(tableData, function(product, index) {
                product.dataLength = tableData.length;
                if (this.viewHelpers.isParentRow(product.type)) {

                    if (product.mergeSelected === true || ([true, 'true'].includes($('#mitelSubscriptionOrder').val()) && product.enableCheckBox)) {
                        product.rowClass = (lineRowIndex % 2 === 0) ? 'odd selected' : 'even selected';
                    } else {
                        product.rowClass = (lineRowIndex % 2 === 0) ? 'odd' : 'even';
                    }

                    parentRowIndex = index;
                    lineRowIndex++;
                }
                else {
                    product.rowClass = (lineRowIndex % 2 === 0) ? 'odd' : 'even';
                    lineRowIndex++;
                }

                model = new ws.models.modalTableProductModel(product);
                tableRow = new ws.views.modalTableProductRowView({
                    model: model,
                    template: this.tableRowTemplate,
                    $tableContainer: this.$tableContainer,
                    viewHelpers: this.viewHelpers
                });

                if (model.get('vendorSalesDetailsEnabled') === true || model.get('mergeSelected') === true || (([true, 'true'].includes($('#mitelSubscriptionOrder').val()) && model.get('enableCheckBox')))) {
                    model.set('checked', true);
                }

                if (model.get('vpsCloudProduct') === true) {
                    $('.split-order-cloudProduct-errors').show();
                }

                this.collection.add(model);
                this.$table.append(tableRow.render().el);
            }.bind(this));

            //show table once rendered (eg: split order table)
            if (this.showTableOnLoad === true) {
                this.$table.show();
            }

            //make sure all products are selected by default
            if (window.location.href.indexOf('mergequote') > 0) {
                this.eventAgg.trigger('triggerCheckboxCheck');
                this.updateButtons();
            } else {
                this.$selectAllCheckbox.prop('checked', true);
                this.selectAll();
            }

            this.$('.quoteWithRevision').text($('#quoteId').val() + '_Rev' + $('#versionId').val());

        },

        /**
         * Select all products
         */
        selectAll: function() {
            var checkedStatus = this.$selectAllCheckbox.is(':checked');
            var $trs = this.$table.find('tbody > tr');
            var $checkbox;

            _.each($trs, function(tr) {
                $checkbox = $(tr).find('input:checkbox').not(':disabled');
                if ($checkbox.length > 0) {
                    this.toggleRowSelections(tr, checkedStatus);
                }
            }.bind(this));

            this.updateButtons();
        },

        /**
         * Select a row and check checkbox
         * @param {element} tr
         * @param {boolean} toggle
         */
        toggleRowSelections: function(tr, toggle) {
            var $checkbox = $(tr).find('input:checkbox');
            var id = $($checkbox).data('attr');
            var model = this.collection.get(id);

            if (!$checkbox.is(':disabled')) {
                model.set('checked', toggle);
                $(tr).toggleClass('selected', toggle);
                $checkbox.prop('checked', toggle);
            }

        },

        /**
         * Deselect all rows
         */
        deselectAllRows: function() {
            var numberOfRows =  this.$table[0].rows.length;

            for (var i = 1; i < numberOfRows; i++) {
                this.toggleRowSelections($(this.$table[0].rows[i]), false);
            }
        },

        /**
         * Enable multiple row selection
         * @param {Object} e
         */
        multipleRowSelect: function(e) {
            var tr = e.currentTarget;
            var $checkbox = $(tr).find('input:checkbox');

            //don't toggle row if clicking on input (unless it's a checkbox and not disabled)
            if (!$(e.target).is('input:not(:checkbox)') && !$(e.target).is('input:disabled') && !$checkbox.is(':disabled')) {
                e.preventDefault();

                if (!e.shiftKey) {
                    this.previousSelectedRow = tr;
                    this.toggleRowSelections(tr, !$(tr).hasClass('selected'));
                } else {
                    this.previousSelectedRow = this.$table.find('tr.selected')[0];
                    this.deselectAllRows();

                    var firstRow = Math.min(this.previousSelectedRow.rowIndex, tr.rowIndex);
                    var lastRow = Math.max(this.previousSelectedRow.rowIndex, tr.rowIndex);

                    for (var i = firstRow; i <= lastRow; i++) {
                        //text in DataTables gets highlighted by default, so need to deselect it
                        if (window.getSelection) {
                            window.getSelection().removeAllRanges();
                        }

                        this.toggleRowSelections($(this.$table[0].rows[i]), true);
                    }
                }

                this.updateButtons();
            }

        },

        /**
         * Update button states and select all checkbox state
         */
        updateButtons: function() {
            var activeRows = this.$table.find('td input:checkbox').not(':disabled');
            this.$selectAllCheckbox.prop('checked', this.collection.getSelectedItemsForSelectAllCheckbox().length === activeRows.length);
        },

        /**
         * Toggle which products are selected
         * @param {Event} e
         */
        toggleProduct: function(e) {
            var id = $(e.currentTarget).data('attr');
            var model = this.collection.get(id);
            var $tr = $(e.currentTarget).closest('tr');
            var isChecked = $(e.currentTarget).is(':checked');

            model.set('checked', isChecked);
            $tr.toggleClass('selected', isChecked);

            this.updateButtons();
        },

        /**
         * Extend default close modal function
         */
        closeModal: function() {
            ws.views.modal.prototype.closeModal.call(this);
            this.$table.find('tbody').empty();

            //hide table if it should not be rendered on modal open
            if (this.showTableOnLoad === false) {
                this.hideTable();
            }
        },

        /**
         * Build View helpers object to be used on template
         */
        buildViewHelpers: function() {
            var _this = this;
            this.viewHelpers = {
                /**
                 * returns if element is bundle parent
                 * @param {string} type
                 * @returns {boolean}
                 */
                isBundleParent: function(type) {
                    return _this.ROLLUP_PARENT_BUNDLE_TYPE === type || _this.TOPDOWN_PARENT_BUNDLE_TYPE === type || _this.CISCO_PARENT_BUNDLE_TYPE === type || type === 'SCONTP';
                },
                /**
                 * returns if element is bundle child
                 * @param {string} type
                 * @returns {boolean}
                 */
                isBundleChild: function(type) {
                    return _this.ROLLUP_CHILD_BUNDLE_TYPE === type || _this.TOPDOWN_CHILD_BUNDLE_TYPE === type || _this.CISCO_CHILD_BUNDLE_TYPE === type || type === 'SCONTC' || type === 'PER_UNIT_SUBSCRIPTION' || type === 'FULL_TERM_ITEM_CHILD';
                },
                /**
                 * returns if element is parent row
                 * @param {string} type
                 * @returns {boolean}
                 */
                isParentRow: function(type) {
                    return _this.ROLLUP_PARENT_BUNDLE_TYPE === type || _this.TOPDOWN_PARENT_BUNDLE_TYPE === type || _this.STANDARD_TYPE === type || _this.TECEX_TYPE === type || _this.VENDOR_PARENT_TYPE === type || _this.CISCO_PARENT_BUNDLE_TYPE === type || type === 'SCONTP' || type === 'SUBSCRIPTION' || type === 'PER_UNIT_SUBSCRIPTION' || type === 'CONSOLIDATED' || type === 'FULL_TERM_ITEM_CHILD' || type === 'CONFIGURED_PARENT';
                },
                /**
                 * returns if element should render checkbox
                 * @param {string} type
                 * @returns {boolean}
                 */
                renderSAPValidationChk: function (type) {
                    return _this.TOPDOWN_PARENT_BUNDLE_TYPE === type || _this.STANDARD_TYPE === type || _this.TECEX_TYPE === type || _this.ROLLUP_CHILD_BUNDLE_TYPE === type || _this.CISCO_PARENT_BUNDLE_TYPE === type  || _this.CISCO_CHILD_BUNDLE_TYPE === type || type === 'SCONTP';
                },
                /**
                 * returns element's cell class
                 * @param {string} type
                 * @param {integer} length
                 * @param {integer} id
                 * @returns {*}
                 */
                getCellClass: function(type, length, id) {
                    switch (type) {
                        case _this.ROLLUP_PARENT_BUNDLE_TYPE:
                        case _this.TOPDOWN_PARENT_BUNDLE_TYPE:
                        case _this.CISCO_PARENT_BUNDLE_TYPE:
                            return 'bundle-parent';
                        case _this.ROLLUP_CHILD_BUNDLE_TYPE:
                        case _this.TOPDOWN_CHILD_BUNDLE_TYPE:
                        case _this.CISCO_CHILD_BUNDLE_TYPE:
                            return (length === id) ? 'bundle-child-last' : 'bundle-child';
                        default:
                            return '';
                    }
                }
            };
        }

    });
})(westcon);
